import { render, staticRenderFns } from "./Projectintroduction.vue?vue&type=template&id=2f608f28&scoped=true"
import script from "./Projectintroduction.vue?vue&type=script&lang=js"
export * from "./Projectintroduction.vue?vue&type=script&lang=js"
import style0 from "./Projectintroduction.vue?vue&type=style&index=0&id=2f608f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f608f28",
  null
  
)

export default component.exports